// Central clinic info & non-translatable static data.
// NAP (Name / Address / Phone) MUST match exactly Google Business Profile.
export const CLINIC = {
  name: "Instituto Clínico do Barlavento",
  tagline: "Médico e Dentário",
  address: "Rua Teófilo Braga 29, 8500-668 Portimão",
  addressEncoded: "Rua+Te%C3%B3filo+Braga+29,+8500-668+Portim%C3%A3o",
  phone: "+351 282 427 230",
  phoneRaw: "+351282427230",
  whatsapp: "+351 966 656 631",
  whatsappRaw: "351966656631",
  email: "info@institutobarlavento.com",
  logo: "https://customer-assets.emergentagent.com/job_barlavento-dental/artifacts/kuiuli9p_LOGOTIPO%20transparente.png",
  geo: { lat: 37.1365382, lng: -8.5404839 },
  // Google Place ID for the clinic — used for direct "write a review" deep link.
  placeId: "ChIJEYICI_IoGw0RiuHA4ZlWVWw",
  socials: {
    instagram: "https://www.instagram.com/institutoclinicodobarlavento/",
    facebook: "https://www.facebook.com/institutoclinicobarlavento/",
  },
};

// Schedule structure — day labels translated via t('day.xxx'), hours are numeric/universal
export const HOURS = [
  { dayKey: "day.monWed", h: "09:30–13:00 · 15:00–19:00" },
  { dayKey: "day.thuFri", h: "09:30–13:00 · 14:00–18:00" },
  { dayKey: "day.satSun", hKey: "day.closed" },
];

// Service catalogue — name/desc keys resolved by i18n.
// 4 featured services for the homepage; each links to a dedicated SEO landing page.
export const FEATURED_SERVICES = [
  { key: "implantes", icon: "Anchor", slug: "implantes-dentarios-portimao" },
  { key: "alinhadores", icon: "AlignJustify", slug: "alinhadores-invisiveis-portimao" },
  { key: "estetica", icon: "Sparkles", slug: "estetica-reabilitacao-portimao" },
  { key: "ortodontia", icon: "Activity", slug: "ortodontia-portimao" },
];

// Service catalogue — 12 cards on homepage. Some link to dedicated SEO landing pages.
export const SERVICE_KEYS = [
  { key: "implantes", icon: "Anchor" },
  { key: "ortoEsp", icon: "Activity" },
  { key: "alinhadores", icon: "AlignJustify" },
  { key: "bran", icon: "Sparkles" },
  { key: "est", icon: "Smile" },
  { key: "endo", icon: "Zap" },
  { key: "perio", icon: "Leaf" },
  { key: "ped", icon: "Baby" },
  { key: "atm", icon: "PersonStanding" },
  { key: "prot", icon: "Cpu" },
  { key: "cir", icon: "Scissors" },
  { key: "canc", icon: "Stethoscope" },
];

export const REASON_KEYS = [
  { idx: 1, icon: "Microscope" },
  { idx: 2, icon: "Award" },
  { idx: 3, icon: "MapPin" },
];

// Helpers for Maps & Reviews URLs (centralised so we can swap Place ID in one place)
export const MAPS_URLS = {
  directions: `https://www.google.com/maps/dir/?api=1&destination=${CLINIC.addressEncoded}&destination_place_id=${CLINIC.placeId}`,
  writeReview: `https://search.google.com/local/writereview?placeid=${CLINIC.placeId}`,
  embed: `https://maps.google.com/maps?ll=${CLINIC.geo.lat},${CLINIC.geo.lng}&z=18&q=${CLINIC.addressEncoded}&output=embed`,
};
